function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 24/9/2025</p>
    </div>)
}

export default Footer
;
